import { APP_INITIALIZER, NgModule } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS, HttpClientJsonpModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from 'src/app/shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutComponent } from './layout/layout.component';
import { AgmCoreModule } from '@agm/core';
import { FooterComponent } from './components';
import { HealthCheckComponent } from '@components';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { StartupService } from '../core/services/startup/startup.service';
import { ErrorComponent } from './components/error/error.component';
import { SitemapComponent } from './components/sitemap/sitemap.component';
import { FormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';

export function StartupServiceFactory(startupService: StartupService) {
    return () => {};
}
@NgModule({
    declarations: [
        AppComponent,
        LayoutComponent,
        FooterComponent,
        HealthCheckComponent,
        ErrorComponent,
        SitemapComponent,
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'serverApp' }),
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        HttpClientJsonpModule,
        SharedModule,
        MultiSelectModule,
        FormsModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyDXk_Np8JpVCzWsrThRnHev84q_38XSETw',
            libraries: ['places'],
        }),
        TranslateModule.forRoot(),
    ],
    providers: [
        TranslateService,
        HttpClient,
        StartupService,
        {
            provide: APP_INITIALIZER,
            useFactory: StartupServiceFactory,
            deps: [StartupService],
            multi: true,
        },
        { provide: APP_BASE_HREF, useValue: '/op' },
    ],
    bootstrap: [AppComponent],
    exports: [TranslateModule],
})
export class AppModule {}
